export default __webpack_public_path__ + "static/media/BD.cba89210.svg";